import useSWR from 'swr';
import { getGlobalStats } from '..';

const useGlobalStats = () => {
  const { data, isValidating, error } = useSWR(
    'insightimer/global_state',
    () => {
      return getGlobalStats();
    },
    {
      revalidateOnFocus: false,
      refreshWhenOffline: false
    }
  );

  const globalStats = data ?? {};
  const isGlobalStatsLoading = isValidating && !data;
  const errMessage = error ? String(error) : '';

  return {
    ...globalStats,
    isGlobalStatsLoading,
    errMessage
  };
};

export default useGlobalStats;
